import {SkeletonBasic} from '@web-catalog/ui-kit/SkeletonBasic';

import styles from './CategoriesListSkeleton.module.scss';

const SKELETON_CARDS = 14;

export const CategoriesListSkeleton = () => {
  return (
    <div>
      {[...Array(SKELETON_CARDS)].map((_, idx) => (
        <li key={idx}>
          <div className={styles.category}>
            <SkeletonBasic className={styles.icon} radius={4} />
            <SkeletonBasic className={styles.title} radius={4} />
          </div>
        </li>
      ))}
    </div>
  );
};
